import React from 'react';

export type CandidateLinkRow = {
  id: string;
  simulation: string;
  jobReferenceTitle: string;
  status: 'ACTIVE' | 'EXPIRED';
  expires: string;
  onCopy: () => void;
};

type CandidateLinksTableProps = {
  rows: CandidateLinkRow[];
  onGenerate: () => void;
};

const CandidateLinksTable: React.FC<CandidateLinksTableProps> = ({ rows, onGenerate }) => {
  const getStatusPillClass = (status: CandidateLinkRow['status']) =>
    status === 'ACTIVE'
      ? 'border-[#8fd5c8] bg-[#e6f7f3] text-[#0f766e]'
      : 'border-[#d7c1ab] bg-[#f6efe8] text-[#8a5a2b]';

  return (
    <div className="rounded-b-[14px] border border-t-0 border-[#e2e5eb] bg-white p-0">
      {rows.length > 0 ? (
        <div className="overflow-x-auto">
          <table className="min-w-[760px] w-full text-left">
            <thead>
              <tr className="bg-[#fafdf9]">
                {['Simulation', 'Job reference/title', 'Status', 'Expires', 'Action'].map((header) => (
                  <th
                    key={header}
                    className="border-b-2 border-[#0d9488] px-4 py-3 text-[11px] font-bold uppercase tracking-[0.08em] text-[#475569]"
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id} className="border-b border-[#f0f0ee] transition-colors last:border-b-0 hover:bg-[#fafdf9]">
                  <td className="px-4 py-3 text-[13px] font-semibold text-[#0f172a]">{row.simulation}</td>
                  <td className="px-4 py-3 text-[13px] text-[#475569]">{row.jobReferenceTitle}</td>
                  <td className="px-4 py-3">
                    <span
                      className={`inline-flex rounded-full border px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.08em] ${getStatusPillClass(row.status)}`}
                    >
                      {row.status === 'ACTIVE' ? 'Active' : 'Expired'}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-[13px] text-[#475569]">{row.expires}</td>
                  <td className="px-4 py-3">
                    <button
                      type="button"
                      onClick={row.onCopy}
                      className="rounded-[10px] border border-[#e2e5eb] bg-white px-3.5 py-2 text-[12px] font-semibold text-[#475569] transition-colors hover:border-[#0d9488] hover:text-[#0d9488]"
                    >
                      Copy
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="px-6 py-10 text-center">
          <p className="font-display text-[20px] font-bold text-[#0f172a]">No candidate links yet</p>
          <p className="mt-2 text-[13px] text-[#64748b]">
            Generate your first shareable simulation link to invite candidates.
          </p>
        </div>
      )}
      <div className="border-t border-[#f0f0ee] px-4 py-3">
        <button
          type="button"
          onClick={onGenerate}
          className="rounded-[10px] bg-[#0d9488] px-5 py-2.5 text-[13px] font-semibold text-white transition-colors hover:bg-[#0f766e]"
        >
          + Generate New Link
        </button>
      </div>
    </div>
  );
};

export default CandidateLinksTable;
